const state = {
  clientesData: [
    {
      id: 1,
      nombre: "Cliente",
      apellido: "Demo",
      telefono: "555 555 5555",
      email: "cliente-demo@ejemplo-mail.com",
      visitas: 2,
      status: 'Turista',
    },
    {
      id: 2,
      nombre: "Leo",
      apellido: "DaVinci",
      telefono: "444 444 4444",
      email: "leodavin@ejemplo-mail.com",
      visitas: 1,
      status: 'VIP',
    },
    {
      id: 3,
      nombre: "Miguel Angel",
      apellido: "Buonarroti ",
      telefono: "333 333 3333",
      email: "michelangelo@ejemplo-mail.com",
      visitas: 1,
      status: 'VIP',
    },
  ],
};

const getters = {
  demoClientes: state => state.clientesData,
};

const actions = {
  getClienteByID: (state, id) => state.clientesData.find(cliente => cliente.id == id),
  addNewDemoCliente: ({commit, state}, clientePayload) => {
    console.log("[state] ",state);
    const lastIDX = state.clientesData.length -1;
    const clientID = state.clientesData[lastIDX].id +1;
    clientePayload.id = clientID;
    commit('addNewCliente', clientePayload);
    return {clientID};
  },
}

const mutations = {
  addNewCliente: (state, payload) => state.clientesData.push(payload),
};


export default {
  state,
  getters,
  actions,
  mutations
};